import React, { Suspense } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AdminNavbar from "../components/navbars/AdminNavbar";
import Sidebar from "../components/sidebars/Sidebar";
import { Spinner } from 'reactstrap';
import AuthorizationHOC from '../hoc/AuthorizationHOC';
import { routes } from "../routes";
import { isEmpty, intersection } from 'lodash';
import { connect } from 'react-redux';
import { getLocalUserState } from '../redux/selectors/authentication';

class Admin extends React.Component {
  state = {
    sidebarMini: true,
  };

  mainPanel = React.createRef();

  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.mainPanel.current.scrollTop = 0;
    }
  }

  minimizeSidebar = () => {
    if (document.body.classList.contains("sidebar-mini")) {
      this.setState({ sidebarMini: false });
    } else {
      this.setState({ sidebarMini: true });
    }
    document.body.classList.toggle("sidebar-mini");
  };

  getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/admin") {
				if(prop.permissions) {
					if( isEmpty(this.props.localUser) ) {
						return null;
					}

					const user_permissions = this.props.localUser.permissions.map( x => x.name );

					if( intersection( user_permissions, prop.permissions ).length === 0 ) {
						return null;
					}
				}

        return (
          <Route
            path={prop.layout + prop.path}
            component={ prop.permissions ? AuthorizationHOC(prop.permissions)(prop.component) : prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  getActiveRoute = routes => {
    let activeRoute = "";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.pathname.indexOf(
            routes[i].layout + routes[i].path
          ) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  render() {
    return (
      <div className="wrapper">
        <Sidebar
          {...this.props}
          routes={routes}
          minimizeSidebar={this.minimizeSidebar}
        />
        <div className="main-panel" ref={this.mainPanel}>
          <AdminNavbar
            {...this.props}
            brandText={this.getActiveRoute(routes)}
          />
          <Suspense fallback={<Spinner color="default" />}>
            <Switch>
              {this.getRoutes(routes)}
              <Route path="/" render={() => {
                return <Redirect to="/companies" />
              }} />
            </Switch>
          </Suspense>
        </div>
      </div>
    );
  }
}

export default connect(
	state => ({ localUser: getLocalUserState(state) })
)(Admin);
